export default __webpack_public_path__ + "static/media/Rey McSriff.33fd4e16.jpg";